import { css } from '@emotion/core';
import { PRIMARY_COLOR, TEXT_COLOR } from './styleVariables';

const resetStyles = css`
  /* CSS reset */
  *,
  *::after,
  *::before {
    box-sizing: border-box;
  }

  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    border: 0;
    font: inherit;
    font-size: 100%;
    margin: 0;
    padding: 0;
    vertical-align: baseline;
  }

  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }

  a {
    text-decoration: none;
  }

  body {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    line-height: 1;
  }

  ol,
  ul {
    list-style: none;
  }

  blockquote,
  q {
    quotes: none;
  }

  blockquote::before,
  blockquote::after,
  q::before,
  q::after {
    content: '';
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  input,
  input[type='email'],
  input[type='button'],
  input[type='submit'],
  input[type='text'],
  input[type='tel'],
  button {
    appearance: none;
  }
`;

const globalStyles = css`
  /* PayPal global rules */
  body {
    color: ${TEXT_COLOR};
    font-family: ${`
        "Helvetica Neue",
        "HelveticaNeue",
        "HelveticaNeue-Light",
        "Helvetica Neue Light",
        helvetica,
        arial,
        Roboto,
        sans-serif
      `};
    margin: 0;
  }

  a {
    /* stylelint-disable-line no-duplicate-selectors */
    color: ${PRIMARY_COLOR};
  }

  a,
  button {
    font-weight: 500;
  }

  input {
    border-style: none;
    font-size: calc(1em * (15 / 16));
    min-width: 0;

    &:focus {
      border: 1px solid ${PRIMARY_COLOR};
      outline: none;
    }
  }

  .app-root {
    font-weight: 500;
    margin: 0 auto;
    max-width: 390px;
    padding: 0 18px;
    @media (min-width: 699px) {
      max-width: 780px;
    }
  }
`;

export { globalStyles, resetStyles };
